{
    "PageTitle": "Rezervace zasedacích místností / hotdesk",
    "location": "Vyberte místo / místnost",
    "date": "Datum",
    "from_date": "Od data",
    "to_date": "Do data",
    "toDateError": "'Do data' musí být stejné nebo pozdější než 'Od data' a maximální rozdíl mezi daty je 30 dní.",
    "topic": "Téma",
    "timeFrom": "Čas začátku",
    "timeUntil": "Čas konce",
    "startTime": "Čas začátku",
    "capacity": "Kolik lidí se zúčastní?",
    "btnSubmit": "Odeslat",
    "btnReset": "Resetovat",
    "formReset": "Resetovat formulář",
    "errMsg": "Prosím, vyplňte všechna pole!",
    "inputPlaceholder": "vstup...",
    "hours": "hodiny",
    "minutes": "minuty",
    "starting": "Začíná",
    "duration": "Doba trvání",
    "btnSearch": "Hledat",
    "locationOptionLabel": "Místo, název / číslo místnosti",
    "startOptionLabel": "Vyberte čas začátku",
    "durationOptionLabel": "Vyberte dobu trvání",
    "capacityOptionLabel": "Vyberte kapacitu",
    "searchText": "prosím čekejte, snažíme se připojit k serveru!",
    "dummyLocationValueOne": "Místo 1",
    "dummyLocationValueTwo": "Místo 2",
    "roomAvailableTextDummy": "Nalezeno 27 prostor pro 24. dubna, 13:00 - 14:00 na Hallstadter Straße 119 - Schulungsgebäude",
    "roomAvailableFound": "Nalezeno",
    "roomAvailableSpaces": "prostor na",
    "roomAvailablein": "v",
    "floorDropdownDummy": " EG Schulungsgebäude",
    "selectedFloorOptionOneDummy": "EG",
    "selectedFloorOptionTwoDummy": "OG",
    "meetingLocationLabel": "Místo setkání",
    "titleOfMeetingLabel": "Název setkání",
    "titleOfMeetingPlaceholder": "Zadejte název nebo téma plánovaného setkání",
    "descOfMeetingPlaceholder": "Přidat popis",
    "meetingDescriptionLabel": "Popis setkání (volitelné)",
    "availableLabel": "Dostupné",
    "busyLabel": "Obsazeno",
    "confirmBookingBtn": "Potvrdit rezervaci",
    "bookingSuccessLabel": "Rezervace místnosti byla úspěšná",
    "bookingFailureLabel": "Něco se pokazilo. Zkuste to prosím později.",
    "selectRoomLocation": "Vyberte místo / místnost",
    "futureDateError": "Prosím, vyberte správné budoucí datum/čas.",
    "noSlotAvailable": "Žádné dostupné termíny",
    "tokenRequired": "Chybí požadovaný přístupový token nebo vypršel.",
    "roomBooked": "Místnost je již rezervována!",
    "roomPartiallyBooked": "Místnost je částečně rezervována!",
    "participantError": "Plánujete rezervaci pro ",
    "participantErrorMsg": " účastníků, ale kapacita místnosti je pouze ",
    "partiallyFree": "Částečně volné",
    "startingTime": "Čas začátku",
    "participants": "Počet účastníků",
    "max": "Max",
    "capacityLabel": "Kapacita ",
    "dashboard": "Zobrazit mé rezervace",
    "manageBookings": "Spravovat rezervace",
    "bookAgain": "Rezervovat znovu",
    "cancelBookingConfrim": "Opravdu chcete zrušit toto setkání?",
    "list": "Seznam",
    "search": "Hledat",
    "type": "Typ",
    "updateBookingApiSucessMsg": "Rezervace byla úspěšně aktualizována",
    "rebookingApiSucessMsg": "Úspěšně rezervováno",
    "cancelBookingApiSucessMsg": "Rezervace byla úspěšně zrušena",
    "noUpcomingBooking": "Momentálně nemáte žádné nadcházející rezervace",
    "noPastBooking": "Momentálně nemáte žádné minulé rezervace",
    "apiFailDefaultMsg": "Něco se pokazilo. Zkuste to prosím později.",
    "confirm": "Potvrdit",
    "cancel": "Zrušit",
    "close": "Zavřít",
    "fieldRequired": "Toto pole je povinné",
    "selectLocation": "Prosím, vyberte místo",
    "selectDate": "Prosím, vyberte datum pro rezervaci",
    "meetingTitleMissing": "Chybí název setkání",
    "numberOfParticipantMissing": "Chybí počet účastníků",
    "gingcoDisclaimer": "MyHelp pomáhá s jednoduchou rezervací místností. Pro další služby Gingco (např. Cateringové služby) se můžete obrátit na Gingco.",
    "availability": {
        "text": "Dostupnost",
        "free": "Ano, dostupné",
        "busy": "Omlouváme se, není dostupné",
        "busyHint": "Zkuste změnit datum nebo čas, můžete také zkontrolovat blízké místnosti",
        "partialFree": "Částečně volná místnost",
        "unknown": "Neznámé"
    },
    "manageBooking": {
        "meetingLocation": "Místo setkání",
        "reschedule": "Přeplánovat",
        "bookAgain": "Rezervovat znovu",
        "rescheduleTo": "Přeplánovat na",
        "cancelMeeting": "Zrušit setkání",
        "searchPlaceholder": "Hledat podle ID setkání, popisu, místa"
    },
    "durationOptions": {
        "15 Min": "15 Min",
        "30 Min": "30 Min",
        "45 Min": "45 Min",
        "1 Hr": "1 Hr",
        "2 Hr": "2 Hr",
        "4 Hr": "4 Hr",
        "8 Hr": "8 Hr"
    },
    "meetingRoomTypes": {
        "All": "Vše",
        "Hot Desk": "Hot Desk",
        "Meeting Room": "Zasedací místnost"
    },
    "peopleCount": "Kolik lidí se účastní?"
}